import { Redirect, Route, RouteProps } from "react-router-dom";

import { AuthStates, getAuthenticationState } from "@shared/api";
import { RobotsNoindex } from "@shared/components";

export const AuthedRoute: React.FC<RouteProps> = (props) => {
  switch (getAuthenticationState()) {
    case AuthStates.Unauthorized:
      return (
        <Redirect
          push
          to={{
            pathname: "/login",
            search: `?return_path=${window.location.pathname}`,
          }}
        />
      );
    case AuthStates.Authorized:
      return (
        <>
          <RobotsNoindex />
          <Route {...props} />
        </>
      );
    default:
      return <div>Error.</div>;
  }
};
